<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Account Service Defaults'"
    [canGoBack]="true"
    [customBack]="'list-settings'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage"
        />
    }

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'TIDY will use any account service default before your address default.'" />
      </tidy-row>
      <tidy-row [alignLastItemRight]="true">
        <tidy-text
          [header]="'Account Service Defaults'" />
        <tidy-text
          [body]="'Add'"
          (action)="goToEditDefaultList('account', 'add')"
          class="link" />
      </tidy-row>
      @for (list of accountServiceDefaultLists; track list) {
        <tidy-card>
          <tidy-card-button (action)="goToEditDefaultList('account', 'edit', list)">
            <tidy-row>
              <tidy-text
                [body]="list?.title" /><br>
              <tidy-text
                [helper]="list?.default_list_setting?.service_name" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
      @if (accountServiceDefaultLists?.length == 0 && allToDoLists?.length !== 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'None added'" />
          </tidy-row>
        </tidy-alert>
      }
      @if (allToDoLists?.length == 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'You haven\'t added any templates to make into account service defaults. Please go to the'" /><span>&nbsp;</span>
              <tidy-text
                [actionBody]="'list settings'"
                class="link"
                (action)="goToListSettings()" /><span>&nbsp;</span>
                <tidy-text
                  [body]="'page and make one of your lists a template to make it an account service default. The list cannot have rooms specific to an address to make it a template.'" />
              </tidy-row>
            </tidy-alert>
          }
          <!--<tidy-row>
          <tidy-filter
            [initValue]="addressId"
            [items]="addressFilter"
            [fitContent]="true"
            (optionChange)="changeAddress($event)">
          </tidy-filter>
        </tidy-row>
        <tidy-row [alignLastItemRight]="addressDefaultLists?.length == 0">
          <tidy-text
            [header]="'Address Default'">
          </tidy-text>
          <tidy-text
            *ngIf="addressDefaultLists?.length == 0"
            [body]="'Add'"
            (action)="goToEditDefaultList('address', 'add')"
            class="link">
          </tidy-text>
        </tidy-row>
        <tidy-card *ngFor="let list of addressDefaultLists; trackBy: trackByList">
          <tidy-card-button (action)="goToEditDefaultList('address', 'edit', list)">
            <tidy-row>
              <tidy-text
                [body]="list?.title">
              </tidy-text>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
        <tidy-alert *ngIf="addressDefaultLists?.length == 0">
          <tidy-row>
            <tidy-text
              [body]="'None added for this address'">
            </tidy-text>
          </tidy-row>
        </tidy-alert>-->
      }
    </tidy-wrapper>
  </ng-template>

  <app-scroll-wrapper [templateContent]="content" />
